import Techvaganza25Page from "../components/pages/Techvaganza-25";

export default Techvaganza25Page;
